"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lang_1 = require("utils/lang");
var currency_1 = require("utils/currency");
var banner_1 = require("utils/playground/banner");
var website_1 = require("utils/website");
var s = require("./index.scss");
var orange = currency_1.ltMiniColor.orange;
var EmptyPage = (function (_super) {
    __extends(EmptyPage, _super);
    function EmptyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLang = lang_1.getLitbLangFn();
        _this.btnClick = function () {
            location.href = "/";
        };
        return _this;
    }
    EmptyPage.prototype.render = function () {
        return (React.createElement("div", { className: s.emptyWrap },
            React.createElement("img", { className: s.img, src: banner_1.GetErrorImage() }),
            React.createElement("p", { className: s.text }, this.getLang("error_message")),
            React.createElement("div", { className: s.btn, onClick: this.btnClick, style: website_1.isLTMini() ? { backgroundColor: orange } : {} }, this.getLang("go_shopping"))));
    };
    return EmptyPage;
}(React.Component));
exports.default = EmptyPage;
